// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_eZS","cls2":"FeedbackForm-cls2_NRT FeedbackForm-cls1_eZS"};